[
  {
    "identifier": "match_offer_date",
    "header": "Offer Date",
    "field": "offer_date.display",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_donor_code",
    "header": "Donor Code",
    "field": "donor.code",
    "editable": false,
    "statusIcon": true,
    "isVisible": true
  },
  {
    "identifier": "match_donor_bmi",
    "header": "Donor BMI",
    "field": "donor.bmi",
    "editable": false,
    "statusIcon": true,
    "isVisible": true
  },
  {
    "identifier": "match_code",
    "header": "Match Code",
    "field": "code",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_transplant_center",
    "header": "TxC",
    "field": "transplantCenter.code",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_organ",
    "header": "Organ",
    "field": "organ.name",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_opo",
    "header": "OPO",
    "field": "donor.opo.code",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "service_level_calculated",
    "header": "SL-C",
    "field": "calculated_stats.service_level",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "service_level_override",
    "header": "SL-O",
    "field": "service_level_override",
    "editable": true,
    "columnType": "dropdown",
    "style": "p-select-dropdown-extend",
    "options": [
      { "label": "Triage", "value": "Triage" },
      { "label": "Handled", "value": "Handled" }
    ],
    "placeholder": "Select..",
    "isVisible": false
  },
  {
    "identifier": "service_level_applicable",
    "header": "SL-A",
    "field": "calculated_stats.applicable_service_level",
    "statusIcon": true,
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "service_level_error",
    "header": "SL-E ",
    "field": "calculated_stats.service_level_error",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_final_disposition_code",
    "header": "FD (Old)",
    "field": "final_disposition.code",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_code",
    "header": "FD",
    "field": "calculated_stats.final_disposition.code",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_code_override",
    "header": "FD-O",
    "field": "calculated_stats.final_disposition_override.id",
    "editable": true,
    "columnType": "dropdown",
    "style": "p-select-dropdown-extend",
    "options": "finalDispositionCodes",
    "placeholder": "Select..",
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_code_applicable",
    "header": "FD-A ",
    "field": "calculated_stats.final_disposition_applicable.code",
    "statusIcon": true,
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_final_disposition_note",
    "header": "FD-Note (Old)",
    "field": "final_disposition_notes",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_note",
    "header": "FD-Notes",
    "field": "calculated_stats.final_disposition_notes",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_note_override",
    "header": "FD-Note Override",
    "field": "calculated_stats.final_disposition_notes_override",
    "editable": true,
    "columnType": "textArea",
    "isVisible": true
  },
  {
    "identifier": "match_calculated_final_disposition_note_applicable",
    "header": "FD-Notes Applicable",
    "field": "calculated_stats.final_disposition_notes_applicable",
    "editable": false,
    "isVisible": true
  },
  {
    "identifier": "donor_dcd",
    "header": "DCD",
    "field": "donor.dcd_criteria_meets.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "donor_abo",
    "header": "ABO",
    "field": "donor.blood_type",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "donor_age",
    "header": "Age",
    "field": "donor.age",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "donor_birthsex",
    "header": "Birth Sex",
    "field": "donor.birthsex",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "donor_kdpi",
    "header": "KDPI",
    "field": "donor.kdpi",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "donor_crossclamp_date",
    "header": "Crossclampdate",
    "field": "donor.cross_clamp_datetime.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_recipient_name",
    "header": "1st Recip Name",
    "field": "calculated_stats.first_recipient_full_name",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_auto_rule_out",
    "header": "ARO",
    "field": "auto_rule_out",
    "editable": true,
    "columnType": "checkbox",
    "editorProps": { "binary": true },
    "isVisible": false
  },
  {
    "identifier": "match_physician",
    "header": "Match decline physician",
    "field": "physician",
    "editable": true,
    "columnType": "textInput",
    "isVisible": false
  },
  {
    "identifier": "match_decline_note",
    "header": "Match decline note",
    "field": "decline_note",
    "editable": true,
    "columnType": "textArea",
    "isVisible": false
  },
  {
    "identifier": "match_recipient_physician",
    "header": "Combined Recipients physician",
    "field": "derive_combined_recipients_physician",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_recipient_notes",
    "header": "Combined Recipients notes",
    "field": "derive_combined_recipients_notes",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_declined_recipient_details",
    "header": "Recipients Decline",
    "field": "calculated_stats.declined_recipient_details",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_users",
    "header": "Users",
    "field": "calculated_stats.users_who_made_changes",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_coordinator_note",
    "header": "Coordinator Notes",
    "field": "coordinator_note.note",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "checklist_status",
    "header": "Checklist status",
    "field": "checklistStatus",
    "editable": false,
    "isVisible": false,
    "permission": "internal_match_checklists"
  },
  {
    "identifier": "match_calculated_notified",
    "header": "Notified",
    "field": "calculated_stats.notified.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_revoked",
    "header": "Revoked",
    "field": "revoked.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_decline_1_refused",
    "header": "Decline 1",
    "field": "calculated_stats.unique_decline_codes_1_refused",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_decline_2_refused",
    "header": "Decline 2",
    "field": "calculated_stats.unique_decline_codes_2_refused",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_decline_1_bypassed",
    "header": "Bypass 1",
    "field": "calculated_stats.unique_decline_codes_1_bypassed",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_decline_2_bypassed",
    "header": "Bypass 2",
    "field": "calculated_stats.unique_decline_codes_2_bypassed",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_total_recipients",
    "header": "Total recipients",
    "field": "calculated_stats.total_recipients",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_total_refused_offers",
    "header": "Total Refused",
    "field": "calculated_stats.total_refused_offers",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_total_bypassed_offers",
    "header": "Total Bypass",
    "field": "calculated_stats.total_bypassed_offers",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_seq",
    "header": "1st #",
    "field": "calculated_stats.first_seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_refused_seq",
    "header": "1st Refused #",
    "field": "calculated_stats.first_refused_seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_bypassed_seq",
    "header": "1st Bypass #",
    "field": "calculated_stats.first_bypassed_seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_blank_seq",
    "header": "1st Blank #",
    "field": "calculated_stats.first_blank_seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_py_seq",
    "header": "1st PY #",
    "field": "calculated_stats.first_py_seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_accepted_seq",
    "header": "1st Accepted #",
    "field": "calculated_stats.first_accepted_current_tc.seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_accepted_organ",
    "header": "1st Accepted Organ",
    "field": "calculated_stats.first_accepted_current_tc.organ",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_second_accepted_seq",
    "header": "2nd Accepted #",
    "field": "calculated_stats.second_accepted_current_tc.seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_second_accepted_organ",
    "header": "2nd Accepted Organ",
    "field": "calculated_stats.second_accepted_current_tc.organ",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_first_prov_yes_seq_any_tc",
    "header": "1st PY # (all TxCs)",
    "field": "first_prov_yes_seq_any_tc",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_first_accepted_seq_any_tc",
    "header": "1st Accepted # (all TxCs)",
    "field": "calculated_stats.first_accepted_any_tc.seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_first_accepted_organ_any_tc",
    "header": "1st Accepted Organ (all TxCs)",
    "field": "calculated_stats.first_accepted_any_tc.organ",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_first_accepted_tc",
    "header": "1st Accepted TxC (all TxCs)",
    "field": "calculated_stats.first_accepted_any_tc.tc",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_second_accepted_seq_any_tc",
    "header": "2nd Accepted # (all TxCs)",
    "field": "calculated_stats.second_accepted_any_tc.seq",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_second_accepted_organ_any_tc",
    "header": "2nd Accepted Organ (all TxCs)",
    "field": "calculated_stats.second_accepted_any_tc.organ",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_second_accepted_tc",
    "header": "2nd Accepted TxC (all TxCs)",
    "field": "calculated_stats.second_accepted_any_tc.tc",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_primary_notified",
    "header": "Primary Notify",
    "field": "calculated_stats.primary_notified.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_calculated_backup_notified",
    "header": "Backup Notify",
    "field": "calculated_stats.backup_notified.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_expedited_email",
    "header": "Expedited Email",
    "field": "expedited.display",
    "editable": false,
    "isVisible": false
  },
  {
    "identifier": "match_case_created",
    "header": "Case",
    "field": "case",
    "editable": true,
    "columnType": "checkbox",
    "editorProps": { "binary": true },
    "isVisible": false
  },
  {
    "identifier": "donor_non_recovery_code",
    "header": "Donor NR",
    "field": "donor.non_recovery_id",
    "editable": true,
    "columnType": "dropdown",
    "style": "p-select-dropdown-extend",
    "options": "nonRecoveries",
    "placeholder": "Select..",
    "isVisible": false
  },
  {
    "identifier": "match_first_accepted_transplant_date",
    "header": "Tx Date 1",
    "field": "first_accepted_transplant_details.transplant_date.display",
    "editable": true,
    "columnType": "textInput",
    "mask": true,
    "placeholder": "MM/DD/YYYY",
    "isVisible": false
  },
  {
    "identifier": "match_second_accepted_transplant_date",
    "header": "Tx Date 2",
    "field": "second_accepted_transplant_details.transplant_date.display",
    "editable": true,
    "columnType": "textInput",
    "mask": true,
    "placeholder": "MM/DD/YYYY",
    "isVisible": false
  },
  {
    "identifier": "match_organ_non_recovery_first",
    "header": "Organ NR 1st",
    "field": "first_accepted_transplant_details.organ_non_recovery",
    "editable": true,
    "columnType": "dropdown",
    "style": "p-select-dropdown-extend",
    "options": [
      { "label": "Yes", "value": "Yes" },
      { "label": "No", "value": "No" }
    ],
    "placeholder": "Select..",
    "isVisible": false
  },
  {
    "identifier": "match_organ_non_recovery_second",
    "header": "Organ NR 2nd",
    "field": "second_accepted_transplant_details.organ_non_recovery",
    "editable": true,
    "columnType": "dropdown",
    "style": "p-select-dropdown-extend",
    "options": [
      { "label": "Yes", "value": "Yes" },
      { "label": "No", "value": "No" }
    ],
    "placeholder": "Select..",
    "isVisible": false
  }
]
